import { meetingRoomService } from "@/services/api/meetingRoom.service";
import { meetingRoomModel } from "@/models/api/meetingRoom.model";
import { sharedHelper, alertHelper } from "@/utils";
import i18n from "@/i18n";

export const MEETING_ROOM_MODULE = "api/meetingRoom";
export const GET_ALL_MEETING_ROOM = "getAllMeetingRoom";
export const CREATE_MEETING_ROOM = "createMeetingRoom";
export const GET_MEETING_ROOM = "getMeetingRoom";
export const UPDATE_MEETING_ROOM = "updateMeetingRoom";
export const UPDATE_MEETING_ROOM_STATUS = "updateMeetingRoomStatus";
export const DELETE_MEETING_ROOM = "deleteMeetingRoom";

const pagination = () => ({
  pageNumber: 1,
  pageSize: 15,
  lastPage: 1,
  tableRowsCounts: 0,
  total: 0,
});
export const state = {
  list: { data: [], pagination: pagination() },
  details: {},
  status: { list: true, detail: true, save: true },
};
const fail = (commit, error) => {
  commit("failure");
  alertHelper.alertError({
    message: sharedHelper.getErrorMessage(error),
    title: i18n.t("message.error"),
  });
};

export const actions = {
  async [GET_ALL_MEETING_ROOM]({ commit }, { filter }) {
    commit("requesting", "list");
    try {
      const result = await meetingRoomService.getAll(filter);
      commit("listSuccess", result);
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
  async [CREATE_MEETING_ROOM]({ commit, dispatch }, { data, filter }) {
    commit("requesting", "save");
    try {
      const result = await meetingRoomService.store(data);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.createXSuccess", [
          i18n.t("module.meetingRoom"),
        ]),
      });
      await dispatch(GET_ALL_MEETING_ROOM, { filter });
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
  async [GET_MEETING_ROOM]({ commit }, { uuid }) {
    commit("requesting", "detail");
    try {
      const result = await meetingRoomService.show(uuid);
      commit("detailSuccess", result);
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
  async [UPDATE_MEETING_ROOM]({ commit, dispatch }, { data, filter }) {
    commit("requesting", "save");
    try {
      const result = await meetingRoomService.update(data);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.updateXSuccess", [
          i18n.t("module.meetingRoom"),
        ]),
      });
      await dispatch(GET_ALL_MEETING_ROOM, { filter });
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
  async [UPDATE_MEETING_ROOM_STATUS](
    { commit, dispatch },
    { uuid, isActive, filter },
  ) {
    commit("requesting", "save");
    try {
      const result = await meetingRoomService.updateStatus(uuid, isActive);
      commit("success");
      await dispatch(GET_ALL_MEETING_ROOM, { filter });
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
  async [DELETE_MEETING_ROOM]({ commit, dispatch }, { uuid, filter }) {
    commit("requesting", "save");
    try {
      const result = await meetingRoomService.softDelete(uuid);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.deleteXSuccess", [
          i18n.t("module.meetingRoom"),
        ]),
      });
      await dispatch(GET_ALL_MEETING_ROOM, { filter });
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
};

export const mutations = {
  requesting(state, type) {
    state.status[type] = false;
  },
  listSuccess(state, result) {
    const data = Array.isArray(result?.data)
      ? result.data
      : result?.data
      ? [result.data]
      : [];
    state.list.data = data.map(meetingRoomModel);
    state.list.pagination = result?.pagination
      ? sharedHelper.apiPaginationAdapter(result.pagination)
      : { ...pagination(), total: data.length, tableRowsCounts: data.length };
    state.status.list = true;
  },
  detailSuccess(state, result) {
    state.details = meetingRoomModel(result?.data || result || {});
    state.status.detail = true;
  },
  success(state) {
    state.status = { list: true, detail: true, save: true };
  },
  failure(state) {
    state.status = { list: true, detail: true, save: true };
  },
};
